import { isNumber } from 'lodash';

export function computeOpacity(opacity?: number) {
  if (!isNumber(opacity)) return '';

  return `${opacity}%`;
}
